export const PILLARS = [
  {
    num: "01",
    name: "Freedom",
    essence: "The first cut of the thread.",
    body: "Most people spend years living inside expectations they never chose. Freedom starts the day you notice the cage was never locked. It is not given. You take it back inch by inch, usually after something breaks. Every loose thread is a door you finally decide to open.",
  },
  {
    num: "02",
    name: "Chaos",
    essence: "Beauty in the tangle.",
    body: "Everyone gets a season where nothing goes to plan. The job falls through. The relationship ends. The map stops working. Chaos feels like the end of the pattern, but it is usually the material before one. The mess you are standing in right now might be the start of something you cannot see yet. Nothing true was ever made in a straight line.",
  },
  {
    num: "03",
    name: "Truth",
    essence: "Worn without a mask.",
    body: "Most people are performing. Fine at work, fine online, fine in front of family. Truth is saying the quiet thing out loud, at least to yourself. I am not okay. I want more. This is not working. Pretending costs more than failing ever will. Truth is the thread that does not fray.",
  },
  {
    num: "04",
    name: "Grit",
    essence: "Stitched through the storm.",
    body: "Everyone falls short sometimes. Grit is not talent or luck or a mood. It is showing up again the next day when your hands shake and nobody claps. The people you admire are not unbreakable. They just kept stitching. Struggle is not the opposite of the work. It is the material.",
  },
  {
    num: "05",
    name: "Rebellion",
    essence: "A seam against the grain.",
    body: "There is a script most people never question. Be this, by this age, in this order, like everyone else. Rebellion is refusing it. Starting late. Starting over. Wearing your inside out. Conformity is a costume. Take it off.",
  },
  {
    num: "06",
    name: "Wisdom",
    essence: "The old weaver's eye.",
    body: "Wisdom is knowing which threads to keep and which to cut loose. Which people. Which habits. Which versions of yourself. Most of us learn it the hard way, after the mistake, not before. Every knot you survived is holding something beautiful together now.",
  },
];
